export const getStyled = (theme) => ({
  contact: {
    position: 'relative',
    margin: '6px -6px 6px 6px',
    borderRadius: '8px',
    backgroundColor: theme.palette.mode === 'light' ? '#f2f2f2' : '#213445',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    maxWidth: '100%',
    cursor: 'pointer',

    '&:hover': {
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
      backgroundColor: theme.palette.mode === 'light' ? '#f2f2f2' : '#294056',
      transform: 'translateY(-2px)',
      cursor: 'pointer',
    },

    '@media (minResolution: 1.2dppx)': {
      maxWidth: '100%',
    },
  },
  contactNameWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginLeft: '5px',
    marginBottom: '2px',
    color: theme.palette.mode === 'light' ? 'black' : 'white',
  },
  contactNumberWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginLeft: '5px',
    marginBottom: '2px',
    color: theme.palette.mode === 'light' ? 'black' : 'white',
  },
  contactNameLabel: {
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: 'Tahoma, sans-serif',

    '@media (minResolution: 1.2dppx)': {
      fontSize: '0.8rem',
    },
  },
});
